import React, { ReactNode } from "react";
import styled from "styled-components";
import TooltipIcon from "../TooltipIcon";
import Text from "../Text";
import { useMobileMediaQuery } from "../Responsive";

interface InputGroupProps {
  title?: ReactNode;
  size?: "large" | "medium";
  help?: ReactNode;
  hidden?: boolean;
  disabled?: boolean;
  children?: ReactNode;
  [key: string]: any; // For spreading additional props
}

interface InputGroupTitleProps {
  help?: ReactNode;
  children?: ReactNode;
  size?: "large" | "medium";
}

interface InputGroupContainerProps {
  $hidden?: boolean;
  $disabled?: boolean;
}

const InputGroup: React.FC<InputGroupProps> = ({
  title,
  size = "large",
  help,
  hidden,
  disabled,
  children,
  ...props
}) => {
  const isMobile = useMobileMediaQuery();

  return (
    <InputGroupContainer $hidden={hidden} $disabled={disabled} {...props}>
      <InputGroupTitle help={help} size={size}>
        {title}
      </InputGroupTitle>
      <Row className={isMobile ? "mobile" : undefined}>{children}</Row>
    </InputGroupContainer>
  );
};

const InputGroupTitle: React.FC<InputGroupTitleProps> = ({
  help,
  children,
  size
}) =>
  children ? (
    <Text
      variant={size === "large" ? "body" : "bodyMobile"}
      data-cy={"input-group-title"}
    >
      {children}{" "}
      <TooltipIcon
        title={help}
        dataCy={"input-group-tooltip-icon"}
        disabled={undefined}
        dataCyTooltip={undefined}
      />
    </Text>
  ) : null;

const InputGroupContainer = styled.div<InputGroupContainerProps>`
  display: ${(props) => (props.$hidden ? "none" : "flex")};
  flex-direction: column;
  position: relative;

  opacity: ${(props) => (props.$disabled ? "0.5" : "1.0")};

  .ant-form-item {
    margin-bottom: 0 !important;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;

  &.mobile {
    flex-direction: column;
    align-items: stretch;
  }
`;

export default InputGroup;
